module.exports = __webpack_public_path__ + "static/media/banner-background.e33dac4f.webp";